import { pathOr } from 'ramda';

import { Box, HStack, VStack } from '@frontend/components';

import { partViewerRoutePrefix } from 'modules/viewerPage/data/routes';

import HighlightOrDisplay from './HighlightOrDisplay';
import LabelText from './LabelText';
import PartCell from './PartCell';

const PartMatchCell = ({ partResult }) => {
  const primaryFile = pathOr([], ['data', 'partFiles'], partResult).find(
    (partFile) => partFile.isPrimaryFile == true,
  );
  const { uuid: partFileUuid, filename, containsVirus } = primaryFile;
  const exportControlled = pathOr(
    null,
    ['data', 'exportControlled'],
    partResult,
  );
  return (
    <Box alignContent="left">
      <PartCell
        containsVirus={containsVirus}
        primaryFileUuid={partFileUuid}
        filename={filename}
        isExportControlled={exportControlled}
        partResult={partResult}
        href={`${partViewerRoutePrefix}/${partResult.data.uuid}`}
      />
      <HStack paddingTop={1}>
        <VStack alignItems="start" spacing={0}>
          <LabelText>Process</LabelText>
          <LabelText>Material</LabelText>
          <LabelText>Finish</LabelText>
        </VStack>
        <VStack alignItems="start" spacing={0}>
          <HighlightOrDisplay field="process" result={partResult} />
          <HighlightOrDisplay field="material" result={partResult} />
          <HighlightOrDisplay field="finishes" result={partResult} />
        </VStack>
      </HStack>
    </Box>
  );
};

export default PartMatchCell;
